(function() {
    'use strict';

    angular
        .module('app.associationAdmin')
        .component('sc3AssociationAdmin', {
            templateUrl: 'app/association-admin/association-admin.component.html',
            controller: AssociationAdminComponent
        });

    AssociationAdminComponent.$inject = [];
    function AssociationAdminComponent() {
        var ctrl = this;
    }
})();